import { useEffect, useRef, useState } from "react";

/**
 * AdSlot — Google AdSense responsive display unit.
 * Pro users never see ads (ad-free perk). Flip ADS_ENABLED to false to hide all ads.
 * The slot collapses to nothing until a real ad actually fills, so users never see
 * empty "Advertisement" boxes (AdSense only serves on the approved live domain).
 */
const ADS_ENABLED = true;
const AD_CLIENT = "ca-pub-7418938323932291";
const AD_SLOT = "5550081787";

export default function AdSlot({ isPro, variant = "banner", label = "Advertisement", testid }) {
  const insRef = useRef(null);
  const pushed = useRef(false);
  const [status, setStatus] = useState("pending"); // pending | filled | unfilled

  useEffect(() => {
    if (isPro || !ADS_ENABLED) return;
    const ins = insRef.current;
    if (!ins) return;

    if (!pushed.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      } catch (e) {
        /* adsbygoogle not ready yet */
      }
    }

    const read = () => {
      const s = ins.getAttribute("data-ad-status");
      if (s === "filled") setStatus("filled");
      else if (s === "unfilled") setStatus("unfilled");
    };
    read();
    const obs = new MutationObserver(read);
    obs.observe(ins, { attributes: true, attributeFilter: ["data-ad-status"] });
    // If AdSense never reports a status (e.g. non-approved domain), collapse the slot.
    const t = setTimeout(() => {
      if (!ins.getAttribute("data-ad-status")) setStatus("unfilled");
    }, 5000);

    return () => {
      obs.disconnect();
      clearTimeout(t);
    };
  }, [isPro]);

  if (isPro || !ADS_ENABLED || status === "unfilled") return null;

  return (
    <div data-testid={testid || "ad-slot"} data-ad-variant={variant} data-ad-status={status} className="w-full">
      {status === "filled" && (
        <div className="text-[9px] uppercase tracking-[0.2em] text-[#4b5563] font-bold mb-1 text-center">
          {label}
        </div>
      )}
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block", width: "100%" }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={AD_SLOT}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
